module.exports = __webpack_public_path__ + "img/bbdc-screens.943bba8a.png";